export const translationConstants = {
  Invalid_credentials: "Invalid_credentials",
  welcomePara: "welcomePara",
  createAccount: "createAccount",
  firstName: "firstName",
  lastName: "lastName",
  firstNameArabic: "firstNameArabic",
  lastNameArabic: "lastNameArabic",
  nameArabic: "nameArabic",
  Email: "Email",
  phoneNumber: "phoneNumber",
  dateOfBirth: "dateOfBirth",
  gender: "gender",
  createPassword: "createPassword",
  UserList: "UserList",
  confirmPassword: "confirmPassword",
  nationality: "nationality",
  countryOfResidence: "countryOfResidence",
  cityOfResidence: "cityOfResidence",
  uploadDocuments: "uploadDocuments",
  nationalID: "nationalID",
  passport: "passport",
  nationalIDNumber: "nationalIDNumber",
  expiryDate: "expiryDate",
  agreeToTerms: "agreeToTerms",
  SSFRegulations: "SSFRegulations",
  registerButton: "registerButton",
  changeDirectionButton: "changeDirectionButton",
  optional: "optional",
  selectGender: "selectGender",
  selectNationality: "selectNationality",
  selectResidence: "selectResidence",
  selectCityResidence: "selectCityResidence",
  verificationTimeNow: "verificationTimeNow",
  verificationTimeLater: "verificationTimeLater",
  documentType: "documentType",
  uploadDocumentImage: "uploadDocumentImage",
  invalidFirstName: "invalidFirstName",
  invalidLastName: "invalidLastName",
  invalidEmail: "invalidEmail",
  enterValidPhoneNumber: "enterValidPhoneNumber",
  invalidPhoneNumber: "invalidPhoneNumber",
  invalidPassword: "invalidPassword",
  alreadyHaveAccount: "alreadyHaveAccount",
  loginHere: "loginHere",
  registerAsCenter: "registerAsCenter",
  passwordsDoNotMatch: "passwordsDoNotMatch",
  invalidNationalID: "invalidNationalID",
  nationalIDLength: "nationalIDLength",
  enterFirstName: "enterFirstName",
  firstNameRequired: "firstNameRequired",
  enterLastName: "enterLastName",
  lastNameRequired: "lastNameRequired",
  male: "male",
  female: "female",
  other: "other",
  pleaseSelectOne: "pleaseSelectOne",
  documentNo: "documentNo",
  dragDropClickSelectFile: "dragDropClickSelectFile",
  dragDropClickSelectFiles: "dragDropClickSelectFiles",
  directionChange: "directionChange",
  emailRequired: "emailRequired",
  phoneNumberRequired: "phoneNumberRequired",
  dateOfBirthRequired: "dateOfBirthRequired",
  genderSelectionRequired: "genderSelectionRequired",
  passwordRequired: "passwordRequired",
  nationalityRequired: "nationalityRequired",
  countryResidenceRequired: "countryResidenceRequired",
  cityResidenceRequired: "cityResidenceRequired",
  nationalIDNumberRequired: "nationalIDNumberRequired",
  expiryDateRequired: "expiryDateRequired",
  login: "login",
  welcomeBack: "welcomeBack",
  email: "email",
  yourPassword: "yourPassword",
  passwordPlaceholder: "passwordPlaceholder",
  passwordMinLength: "passwordMinLength",
  keepMeSignedIn: "keepMeSignedIn",
  forgotPassword: "forgotPassword",
  loginButton: "loginButton",
  dontHaveAccount: "dontHaveAccount",
  registerHere: "registerHere",
  recoverPasswordInstruction: "recoverPasswordInstruction",
  verificationCodeSent: "verificationCodeSent",
  setNewPassword: "setNewPassword",
  enterYourEmail: "enterYourEmail",
  emailPlaceholder: "emailPlaceholder",
  enterVerificationCode: "enterVerificationCode",
  codePlaceholder: "codePlaceholder",
  enterNewPassword: "enterNewPassword",
  newPasswordPlaceholder: "newPasswordPlaceholder",
  confirmnewPasswordPlaceholder: "confirmnewPasswordPlaceholder",
  codeRequired: "codeRequired",
  enterOnlyNumbers: "enterOnlyNumbers",
  codeMinLength: "codeMinLength",
  Actions: "Actions",
  newPasswordRequired: "newPasswordRequired",
  thankYouForRegistering: "thankYouForRegistering",
  emailForApproval: "emailForApproval",
  thankYouForverification: "thankYouForverification",
  verificationTimeRequired: "verificationTimeRequired",
  name: "name",
  approval: "approval",
  passwordRequirements: "passwordRequirements",
  resetPassword: "resetPassword",
  confirmNewPassword: "confirmNewPassword",
  passwordValidation: "passwordValidation",
  confirmPasswordRequired: "confirmPasswordRequired",
  submit: "submit",
  confirm: "confirm",
  invalidToken: "invalidToken",
  passwordChanged: "passwordChanged",
  documentTypeRequired: "documentTypeRequired",
  imageRequired: "imageRequired",
  registrationSuccess: "registrationSuccess",
  underReview: "underReview",
  receiveApprovalEmail: "receiveApprovalEmail",
  becomeverifieduser: "becomeverifieduser",
  successfullyVerified: "successfullyVerified",
  verifiedDocsFailed: "verifiedDocsFailed",
  goBackHomePage: "goBackHomePage",
  IsUserConsented: "IsUserConsented",
  checkEmail: "checkEmail",
  myProfile: "myProfile",
  dashboard: "dashboard",
  MY_COMPETITIONS: "MY_COMPETITIONS",
  events: "events",
  UnderDevelopment: "UnderDevelopment",
  leaderboard: "leaderboard",
  nationalLeaderboard: "nationalLeaderboard",
  calendar: "calendar",
  competitions: "competitions",
  countriesNotFetch: "countriesNotFetch",
  citiesNotFetch: "citiesNotFetch",
  verificationLinkSent: "verificationLinkSent",
  becomeCertifiedPractitioner: "becomeCertifiedPractitioner",
  courseOutsideKingdomInstruction: "courseOutsideKingdomInstruction",
  selectSport: "selectSport",
  uploadCertificate: "uploadQualification",
  sportType: "sportType",
  sailing: "sailing",
  kitesurfing: "kitesurfing",
  windsurfing: "windsurfing",
  wingfoiling: "wingfoiling",
  cancel: "cancel",
  selectFileOrDragAndDrop: "selectFileOrDragAndDrop",
  fileRequirements: "fileRequirements",
  statusApproved: "statusApproved",
  statusRejected: "statusRejected",
  emailResent: "emailResent",
  documentUploaded: "documentUploaded",
  verifiedDoc: "verifiedDoc",
  expiryData: "expiryData",
  userRequest: "userRequest",
  commentRequired: "commentRequired",
  comments: "comments",
  Approve: "Approve",
  REJECT_QUALIFICATION: "REJECT_QUALIFICATION",
  Reject: "Reject",
  viewUser: "viewUser",
  edit: "edit",
  userUpdateSuccessfully: "userUpdateSuccessfully",
  users: "users",
  instructors: "instructors",
  courses: "courses",
  spots: "spots",
  Search: "Search",
  BecomePractitioner: "BecomePractitioner",
  BecomeInstructor: "BecomeInstructor",
  subscription_settings: "subscription_settings",
  password: "password",
  logout: "logout",
  switchprofile: "switchprofile",
  instructor: "instructor",
  practitioner: "practitioner",
  approvedSuccesfully: "approvedSuccesfully",
  userStateUpdateSuccessfully: "userStateUpdateSuccessfully",
  user: "user",
  documentStatusPending: "documentStatusPending",
  Update: "Update",
  fullName: "fullName",
  selectcity: "select-city",
  selectnationality: "select-nationality",
  selectresidence: "select-residence",
  cityofresidence: "city-of-residence",
  documentssubmitted: "documents-submitted",
  waitadminapproval: "wait-admin-approval",
  becomeVerifiedUser: "becomeVerifiedUser",
  register: "register",
  levelSelectionRequired: "levelSelectionRequired",
  invalid_user_email: "invalid_user_email",
  mode_communication: "mode-communication",
  certificates: "qualifications",
  general: "general",
  documents: "documents",
  documentNoEmpty: "documentNoEmpty",
  Noexpirydate: "Noexpirydate",
  confirmationEmail: "confirmationEmail",
  rowsPerPageText: "rowsPerPageText",
  rangeSeparatorText: "rangeSeparatorText",
  selectDocument: "selectDocument",
  alreadyconfirmed: "alreadyconfirmed",
  password_changed: "password_changed",
  continue: "continue",
  editUser: "editUser",
  UploadDocument: "UploadDocument",
  BECOME_A_VERIFIED_USER: "BECOME_A_VERIFIED_USER",
  FAMILY_CARD: "FAMILY_CARD",
  UPLOAD_QUALIFICATION: "UPLOAD_QUALIFICATION",
  UPLOAD_QUALIFICATION_TEXT: "UPLOAD_QUALIFICATION_TEXT",
  PREFERRED_LANGUAGE: "PREFERRED_LANGUAGE",
  SELECT_PREFERRED_LANGUAGE: "SELECT_PREFERRED_LANGUAGE",
  SELECT_PREFERRED_LANGUAGE_Required: "SELECT_PREFERRED_LANGUAGE_Required",
  PREFERRED_LANGUAGE_COLUMN_NAME: "PREFERRED_LANGUAGE_COLUMN_NAME",
  SELECT_PRIMARY_TEACHING_LOCATION: "SELECT_PRIMARY_TEACHING_LOCATION",
  CHOOSE_SPORTS_YOU_OFFER: "CHOOSE_SPORTS_YOU_OFFER",
  TOTAL_FEE: "TOTAL_FEE",
  YEAR: "YEAR",
  SAR: "SAR",
  FEE_WILL_BE_CALCULATED: "FEE_WILL_BE_CALCULATED",
  I_OWN_ALL_ITEMS: "I_OWN_ALL_ITEMS",
  REQUIREMENT_LIST: "REQUIREMENT_LIST",
  SELECT_PRIMARY_LOCATION: "SELECT_PRIMARY_LOCATION",
  PRIMARY_LOCATION_IS_REQUIRED: "PRIMARY_LOCATION_IS_REQUIRED",
  SSF_FREELANCER_REGULATIONS: "SSF_FREELANCER_REGULATIONS",
  PROCEED_TO_PAYMENT: "PROCEED_TO_PAYMENT",
  VAT: "VAT",
  SUB_TOTAL: "SUB_TOTAL",
  SUBSCRITION_FEE: "SUBSCRITION_FEE",
  PRICING_BREAKDOWN: "PRICING_BREAKDOWN",
  FREELANCE_REGULATION_REQUIRED: "FREELANCE_REGULATION_REQUIRED",
  AGREE_TO_TERMS_REQUIRED: "AGREE_TO_TERMS_REQUIRED",
  SELECT_ONE_SPORT: "SELECT_ONE_SPORT",
  DONE_SUCCESSFULLY: "DONE_SUCCESSFULLY",
  FAILED_TO_PROCEED_PAYMENT: "FAILED_TO_PROCEED_PAYMENT",
  downloadList: "download_list",

  // Admin - Instructor Translations Constants
  instructorList: "instructor_list",
  noDataFound: "no_data_found",
  instructorNotFound: "instructor_not_found",
  centerName: "center_name",
  noOfHours: "no_of_hours",
  noOfStudents: "no_of_students",
  instructorType: "instructor_type",
  instructorRoleCenter: "instructor_role_center",
  instructorRoleFreelance: "instructor_role_freelance",
  instructorRoleNone: "instructor_role_none",
  editInstructor: "edit_instructor",
  viewInstructor: "view_instructor",
  CENTER_NAME: "CENTER_NAME",
  NUM_OF_HOURS: "NUM_OF_HOURS",
  NUM_OF_STUDENTS: "NUM_OF_STUDENTS",
  STATUS: "STATUS",
  QUALIFICATIONS: "QUALIFICATIONS",
  INSTRUCTOR_REQUEST: "INSTRUCTOR_REQUEST",
  CENTER: "Center",
  NONE: "None",
  FREELANCE: "Freelance",

  CHANGE_PASSWORD: "CHANGE_PASSWORD",
  CHANGE_PASSWORD_DESCRIPTION: "CHANGE_PASSWORD_DESCRIPTION",
  CURRENT_PASSWORD: "CURRENT_PASSWORD",
  NEW_PASSWORD: "NEW_PASSWORD",
  CONFIRM_NEW_PASSWORD: "CONFIRM_NEW_PASSWORD",
  UPDATED_SUCCESSFULLY: "UPDATED_SUCCESSFULLY",
  UPDATE_FAILED: "UPDATE_FAILED",
  BECOME_INSTRUCTOR_DESCRIPTION: "BECOME_INSTRUCTOR_DESCRIPTION",
  BECOME_FREELANCE_INSTRUCTOR: "BECOME_FREELANCE_INSTRUCTOR",
  UPDATE_PROFILE: "UPDATE_PROFILE",
  BECOME_A_MEMBER: "BECOME_A_MEMBER",
  ADD_QUALIFICATION: "ADD_QUALIFICATION",
  VERIFICATION_DOCUMENTS: "VERIFICATION_DOCUMENTS",
  NATIONAL_ID_CARD: "NATIONAL_ID_CARD",
  PRACTITIONER: "PRACTITIONER",
  INSTRUCTOR: "INSTRUCTOR",
  WING_FOILING: "WING_FOILING",
  WIND_SURFING: "WIND_SURFING",
  KITE_SURFING: "KITE_SURFING",
  KITESURFING: "KITE_SURFING",
  WINGFOILING: "WING_FOILING",
  WINDSURFING: "WIND_SURFING",
  SAILING: "SAILING",
  MEMBER_SHIP_TAB: "MEMBER_SHIP_TAB",
  CERTIFICATES_TAB: "QUALIFICATION_TAB",
  GENERAL_TAB: "GENERAL_TAB",
  ACTIVITIES: "Activities",
  DOWNLOAD_ENDORSEMENT_LETTER: "DOWNLOAD_ENDORSEMENT_LETTER",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
  PENDING_FOR_APPROVAL: "PENDING_FOR_APPROVAL",
  PENDING: "PENDING",
  PROFILE_IMAGE_NOT_UPLOAD: "PROFILE_IMAGE_NOT_UPLOAD",
  PROFILE_IMAGE_UPDATED: "PROFILE_IMAGE_UPDATED",
  PROFILE_DATA_NOT_FETCH: "PROFILE_DATA_NOT_FETCH",
  ADMIN_USERS: "ADMIN_USERS",
  ADD_ADMIN: "ADD_ADMIN",
  EDIT_ADMIN_USER: "EDIT_ADMIN_USER",
  ADD_ADMIN_USER: "ADD_ADMIN_USER",
  VIEW_ADMIN_USER: "VIEW_ADMIN_USER",
  NAME_ARABIC: "NAME_ARABIC",
  ARABIC: "ARABIC",
  NAME_REQUIRED: "NAME_REQUIRED",
  INVALID_NAME: "INVALID_NAME",
  ENTER_NAME: "ENTER_NAME",
  MEMBER_SHIP_YEARLY_BILLING: "MEMBER_SHIP_YEARLY_BILLING",
  YEARLY_PAYMENT: "YEARLY_PAYMENT",
  NEXT_PAYMENT_DUE: "NEXT_PAYMENT_DUE",
  PAYMENT_HISTORY: "PAYMENT_HISTORY",
  SSF_MEMBER_SHIP: "SSF_MEMBER_SHIP",
  LEARN_MORE: "LEARN_MORE",
  CARD_EXPIRY: "CARD_EXPIRY",
  CARD_NUMBER: "CARD_NUMBER",
  SECURED_BY: "SECURED_BY",
  CARD_DETAILS: "CARD_DETAILS",
  LEVEL: "LEVEL",
  AMOUNT: "AMOUNT",
  DATE: "DATE",
  INVOICE: "INVOICE",
  ARABIC_LANGUAGE: "ARABIC_LANGUAGE",
  ENGLISH_LANGUAGE: "ENGLISH_LANGUAGE",
  // Toast Messages
  user_updated_successfully: "user_updated_successfully",

  DOCUMENT_REJECTED: "document_rejected",

  ACTION_FAILED: "action_failed",
  SUCCESSFULLY_LOGIN: "successfully_login",
  freelance_instructor_created_successfully:
    "freelance_instructor_created_successfully",

  VIEW_SPOT: "view-spot",
  EDIT_SPOT: "edit-spot",
  VIEW_PRIVATE_SPOT: "view_private_spot",
  EDIT_PUBLIC_SPOT: "edit_public_spot",
  VIEW_PUBLIC_SPOT: "view_public_spot",
  CREATE_PUBLIC_SPOT: "create_pulic_spot",
  CREATE_PRIVATE_SPOT: "create_private_spot",
  EDIT_PRIVATE_SPOT: "edit_private_spot",
  SPOT_NAME: "spot_name",
  SPOT_NAME_REQUIRED: "spot-name-required",
  SPOT_LOCATION_NAME: "spot-location-name",
  SPOT_LOCATION_REQUIRED: "spot-loaction-required",
  SPOT_COORDINATES: "spot-coordinates",
  LAT_LONG: "latlong",
  LAT_REQUIRED: "latitudeRequired",
  LNG_REQUIRED: "longitudeRequired",
  FIND_ON_MAP: "findOnMap",
  PREVAILING_WIND_DIRECTION: "usual-wind-direction",
  PREVAILING_WIND_DIRECTION_REQUIRED: "usual-wind-directions-required",
  RELATIVE_TO_SHORE: "relative_to_shore",
  RELATIVE_TO_SHORE_REQUIRED: "relative-to-shore-required",
  PREFERRED_WIND_DIRECTION: "preferred-wind-direction",
  PREFERRED_WIND_DIRECTION_REQUIRED: "preferred-wind-direction-required",
  WIND_SEASONS: "wind-seasons",
  NEAR_WIND_SENSORS_LINK: "near-wind-sensors-link",
  NEAR_WIND_SENSORS_LINK_REQUIRED: "near-wind-sensors-required",
  LINK_TO_WIND_FORECASTS: "link-to-wind-forecasts",
  LINK_TO_WIND_FORECASTS_REQUIRED: "link-to-wind-forecasts-required",
  CITY: "city",
  CITY_IS_REQUIRED: "city_is_required",
  SUITABLE_SPOTS: "suitable-spots",
  SUITABLE_SPOT_REQUIRED: "suitable_spot_required",
  ENTRY_FEES: "entry_fees",
  CAN_BRING_EQUIPMENT: "can_bring_equipment",
  ADD_NEW: "add-new",
  LOCATION: "location",
  CENTERS_AVAILABLE: "centers-available",
  LOADING: "loading",
  ENTER_LONGITUDE: "enter_longitude",
  ENTER_LATITUDE: "enter_latitude",
  SEARCH_PLACES: "search_places",
  LNG_RANGE_VALIDATION_TEXT: "lng_range_validation_text",
  LAT_RANGE_VALIDATION_TEXT: "lat_range_validation_text",
  CENTERS_LIST: "centers_list",
  NUM_OF_INSTRUCTORS: "num_of_instructors",
  PENDING_CENTER: "PENDING_CENTER",
  PAYMENT_REJECTED: "PAYMENT_REJECTED",
  PAYMENT_PENDING: "PAYMENT_PENDING",
  DISABLED: "DISABLED",
  CREATE_CENTER_ACCOUNT: "create_center_account",

  YES: "yes",
  NO: "no",

  IS_NAFES_APPROVED: "is_center_nafes_approved",
  NEED_NAFES_APPROVAL: "need_nafes_approval",

  BASIC: "basic",
  LOCATIONS: "locations",
  NEXT: "next",
  GO_BACK: "go_back",

  ENTER_CENTER_NAME: "enter_center_name",
  INVALID_CENTER_NAME: "invalid_center_name",

  ENTER_CENTER_CITY: "enter_center_city",
  INVALID_CENTER_CITY: "invalid_center_city",

  NAFAS_EXPIRY_DATE: "nafas_expiry_date",
  CENTER_CITY_REQUIRED: "center_city_required",

  WEBSITE_LINK: "website_link",
  ENTER_WEBSITE_LINK: "enter_website_link",
  WEBSITE_LINK_REQUIRED: "website_link_required",
  INVALID_WEBSITE_LINK: "invalid_website_link",

  CONTACT_EMAIL: "contact_email",

  CENTER_DESCRIPTION: "center_description",
  ENTER_CENTER_DESCRIPTION: "enter_center_description",
  CENTER_DESCRIPTION_REQUIRED: "center_description_required",
  INVALID_CENTER_DESCRIPTION: "invalid_center_description",
  SOCIAL_MEDIA_LINKS: "social_media_link",
  TWITTER: "twitter",
  URL_REQUIRED: "url_required",
  INSTAGRAM: "instagram",
  FACEBOOK: "facebook",
  TIKTOK: "tiktok",
  LOGIN_DETAILS_HEADING: "login_details_heading",
  UPLOAD_CENTER_LOGO: "upload_center_logo",

  ATLEAST_ONE_SPORT: "atleast_one_sport",
  NAFES_APPROVAL: "nafes_approval",
  REVIEWS: "Reviews",
  SAILING_CENTER: "sailing_center",
  REJECT_CENTER: "reject_center",
  ADD_LOCATION: "add_location",
  LOCATION_TYPE: "location_type",
  AVAILABLE_SERVICES: "available_services",

  BILLED_ANNUALLY: "billed_annually",
  SPORT_LOCATION: "sport_location",
  TO_BE_PAID_AFTER_APPROVAL: "to_be_paid_after_approval",
  ADD_OPERATING_LOCATION: "add_operating_location",
  OPERATING_LOCATION: "operating_location",
  IS_LOCATION_PUBLIC_PRIVATE: "is_location_public_or_private",
  PUBLIC_SPOT: "public_spot",
  SELECT_PUBLIC_SPOT: "select_public_spot",
  SELECT_PRIVATE_SPOT: "select_private_spot",
  PRIVATE_SPOT: "private_spot",
  SPOT_TYPE_REQUIRED: "spot_type_required",
  SPOT_REQUIRED: "spot_is_required",
  SELECT_SPOT: "select_spot",
  UPLOAD_FOLLOWING_DOCUMENTS: "upload_following_doc",

  SAFETY_PLAN_DOCUMENT: "safety_plan_document",
  OPERATIONAL_PLAN_DOCUMENT: "operational_plan_documents",
  DOCUMENT_REQUIRED: "document_required",
  BEGINNER_LESSONS: "beginner_lessons",
  ADVANCED_LESSONS: "advanced_lessons",
  EQUIPMENT_RENTALS: "equipment_rentals",
  RESCUE: "rescue",
  ATLEAST_ONE_SERVICE: "atleast_one_service",
  LOCATION_SPOTS: "location_spots",
  REJECT_NAFES: "reject_nafes",
  UPDATE_NAFES_DOCUMENT: "update_nafes_document",
  NO_COMMON_SPORT: "no_common_sport",
  AVAILABLE_FOR_TEACHING_ONLY: "available_for_teaching_only",

  REJECT_SPOT: "reject_spot",
  ENTRY_FEES_REQUIRED: "entry_fees_required",
  CENTER_NAME_REQUIRED: "center_name_required",
  ATLEAST_ONE_LOCATION: "atleast_one_location_required",
  VIEW_OPERATING_LOCATION: "view_operating_location",
  EDIT_OPERATING_LOCATION: "edit_operating_location",

  DISABLE: "disable",
  ENABLE: "enable",
  CENTER_PAYMENT: "center_payment",
  cardNumberPlaceholder: "xxxx xxxx xxxx xxxx",
  CVV: "cvv",
  NEXT_PAYMENT_DUE_DATE: "next_payment_due_date",
  CARD_EXPIRY_PLACEHOLDER: "MM/YY",
  CVV_PALCEHOLDER: "xxx",
  SAVE_CARD_INFO: "save_card_info",
  APPLIED_FOR: "applied_for",
  NAFES_LINK_TEXT: "nafes_link_text",

  VERIFIED_USER: "verified_user",
  GENERAL_USER: "general_user",
  TYPE: "type",
  EMAIL_CANT_SAME_AS_CONTACT: "email_cant_same_as_contact",
  SPORTS: "sports",
  HOURS: "hours",
  INSTRUCTORS: "instructors",
  STUDENTS: "STUDENTS",
  NUM_OF_SPOTS: "num_of_spots",
  AVAILABLE_SPORTS: "available_sports",
  UPLOAD_NAFES_APPROVAL: "upload_nafes_approval",
  INVALID_URL_FORMAT: "invalid_url_format",
  DISABLED_INSTRUCTOR_MSG: "disabled_instructor_msg",
  CONTACT_ADMIN: "contact_admin",
  CENTERS: "CENTERS",
  SPORTS_OFFERED: "SPORTS_OFFERED",
  CONTACT_INFORMATION: "CONTACT_INFORMATION",
  DESCRIPTION: "DESCRIPTION",
  VIEW_DETAILS: "VIEW_DETAILS",
  NO_RECORD_FOUND: "no_record_found",
  DELETE_A_USER: "delete_a_user",
  ARE_YOU_SURE: "are_you_sure",
  FROM_ADMIN_LIST: "from_admin_list",
  FROM_CENTER_SPOTS: "from_center_spots",
  DELETE_A_SPOT: "delete_a_spot",
  DROP_THE_FILE_HERE: "DROP_THE_FILE_HERE",
  RATING: "rating",
  ADD_INSTRUCTOR: "add_instructor",
  FIND_INSTRUCTOR: "find_instructor",
  INSTRUCTOR_LEVEL: "instructor_level",
  SEARCH_INSTRUCTOR: "search_instructor",
  REMOVE_INSTRUCTOR: "remove_instructor",
  ARE_YOU_SURE_TO_REMOVE: "are_you_sure_to_remove",
  FROM_INSTRUCTORS_LIST: "from_instructors_list",
  REMOVED: "removed",
  YOU_HAVE_BEEN_INVITED_BY: "you_have_been_invited_by",
  UPDATE_VERIFIED_DOCUMENT: "update_verified_document",
  SPOT_COORDINATES_ALREADY_EXISTS: "spot_coordinates_already_exists",
  FILE_SIZE_LIMIT_ERROR: "file_size_limit_error",
  IMG_IS_REQUIRED: "img_is_required",
  WIND_SEASON: "wind_season",
  WIND_SENSOR_LINK: "wind_sensor_link",
  WIND_DIRECTION: "wind_direction",
  SUITABLE_SPORTS: "suitable_sports",
  GET_DIRECTIONS: "get_directions",
  JOINING_DATE: "JOINING_DATE",
  REMOVE: "remove",
  PLEASE_SELECT_A_CITY: "please_select_a_city",
  ACTIVITY_LINK: "activity_link",
  FILE_TYPE_NOT_ALLOWED: "file_type_not_allowed",
  IMAGE_TYPE_NOT_ALLOWED: "image_type_not_allowed",
  MINIMUM_VALUE_SHOULD_BE_1: "minimum_value_should_be_1",
  UPCOMING_EVENTS_COMPETITIONS: "upcoming_events_competitions",
  NATIONAL_RANKING: "national_ranking",
  NATIONAL_SCORE: "national_score",
  NO_OF_COMPETITIONS: "no_of_competitions",
  REGISTERED_COMPETITIONS: "registered_competitions",
  PREVIOUS_COMPETITIONS: "previous_competitions",
  COURSES_HISTORY: "courses_history",
  RANK: "rank",
  FREELANCE_INSTRUCTOR: "freelance_instructor",
  SPOT_DETAILS: "spot_details",

  //Center Activity Translations
  CENTER_ACTIVITY: "center_activity",
  ACTIVITY: "activity",
  CENTER_ADD_ACTIVITY: "center_add_activity",

  PUBLISHED: "published",
  UNPUBLISHED: "unpublished",
  DRAFT: "draft",
  EXPIRED: "expired",

  OPTIONAL: "OPTIONAL",

  ADD_CENTER_ACTIVITY: "ADD_CENTER_ACTIVITY",
  EDIT_CENTER_ACTIVITY: "EDIT_CENTER_ACTIVITY",
  VIEW_CENTER_ACTIVITY: "VIEW_CENTER_ACTIVITY",

  ENTER_CENTER_ACTIVITY_LINK: "ENTER_CENTER_ACTIVITY_LINK",
  CENTER_ACTIVITY_LINK_REQUIRED: "CENTER_ACTIVITY_LINK_REQUIRED",

  CENTER_ACTIVITY_NAME: "CENTER_ACTIVITY_NAME",
  ENTER_CENTER_ACTIVITY_NAME: "ENTER_CENTER_ACTIVITY_NAME",
  CENTER_ACTIVITY_NAME_REQUIRED: "CENTER_ACTIVITY_NAME_REQUIRED",
  INVALID_CENTER_ACTIVITY_NAME: "INVALID_CENTER_ACTIVITY_NAME",
  CENTER_ACTIVITY_NAME_TOO_LONG: "CENTER_ACTIVITY_NAME_TOO_LONG",
  CENTER_ACTIVITY_ARABIC_NAME_TOO_LONG: "CENTER_ACTIVITY_ARABIC_NAME_TOO_LONG",
  CENTER_ACTIVITY_LINK_TOO_LONG: "CENTER_ACTIVITY_LINK_TOO_LONG",
  CENTER_ACTIVITY_DESCRIPTION_TOO_LONG: "CENTER_ACTIVITY_DESCRIPTION_TOO_LONG",
  CENTER_ACTIVITY_ARABIC_DESCRIPTION_TOO_LONG:
    "CENTER_ACTIVITY_ARABIC_DESCRIPTION_TOO_LONG",

  CENTER_START_DATE: "center_start_date",
  CENTER_START_DATE_REQUIRED: "center_start_date_required",

  CENTER_END_DATE: "center_end_date",
  CENTER_END_DATE_REQUIRED: "center_end_date_required",
  CENTER_END_DATE_NOT_BEFORE_START_DATE:
    "CENTER_END_DATE_NOT_BEFORE_START_DATE",

  CENTER_START_TIME: "CENTER_START_TIME",
  CENTER_START_TIME_REQUIRED: "CENTER_START_TIME_REQUIRED",
  CENTER_START_TIME_NOT_BEFORE_CURRENT_TIME:
    "CENTER_START_TIME_NOT_BEFORE_CURRENT_TIME",

  CENTER_END_TIME: "CENTER_END_TIME",
  CENTER_END_TIME_NOT_BEFORE_START_TIME:
    "CENTER_END_TIME_NOT_BEFORE_START_TIME",

  CENTER_ACTIVITY_DESCRIPTION: "CENTER_ACTIVITY_DESCRIPTION",
  ENTER_CENTER_ACTIVITY_DESCRIPTION: "ENTER_CENTER_ACTIVITY_DESCRIPTION",
  CENTER_ACTIVITY_DESCRIPTION_REQUIRED: "CENTER_ACTIVITY_DESCRIPTION_REQUIRED",

  CENTER_ACTIVITY_LOCATION: "CENTER_ACTIVITY_LOCATION",
  CENTER_ACTIVITY_LOCATION_REQUIRED: "CENTER_ACTIVITY_LOCATION_REQUIRED",
  SELECT_CENTER_ACTIVITY_LOCATION: "SELECT_CENTER_ACTIVITY_LOCATION",

  UPLOAD_POSTER_IMAGE: "UPLOAD_POSTER_IMAGE",
  UPLOAD_LOGO: "UPLOAD_LOGO",

  CREATE_AND_PUBLISH: "CREATE_AND_PUBLISH",
  SAVE_DRAFT: "SAVE_DRAFT",
  UNPUBLISH: "UNPUBLISH",
  PUBLISH: "PUBLISH",

  DELETE_ACTIVITY: "DELETE_ACTIVITY",
  FROM_ACTIVITY_LIST: "FROM_ACTIVITY_LIST",
  CENTER_DESCRIPTION_TOO_LONG: "CENTER_DESCRIPTION_TOO_LONG",
  CENTER_ARABIC_DESCRIPTION_TOO_LONG: "CENTER_ARABIC_DESCRIPTION_TOO_LONG",
  PUBLIC: "public",
  PRIVATE: "private",

  PLEASE_GET_REMOVED_FROM_CENTER_TO_BECOME_FREELANCE_INSTRUCTOR:
    "PLEASE_GET_REMOVED_FROM_CENTER_TO_BECOME_FREELANCE_INSTRUCTOR",
  CREATE_AN_EVENT: "CREATE_AN_EVENT",
  UPDATE_AN_EVENT: "UPDATE_AN_EVENT",

  event_title: "event_title",
  event_title_is_required: "event_title_is_required",
  enter_event_title: "enter_event_title",
  enter_event_description: "enter_event_description",
  event_type: "event_type",
  exclusive_for_members: "exclusive_for_members",
  exclusive_for_members_is_required: "exclusive_for_members_is_required",
  event_start_date: "event_start_date",
  event_start_date_is_required: "event_start_date_is_required",
  event_end_date: "event_end_date",
  event_end_date_is_required: "event_end_date_is_required",
  event_start_time: "event_start_time",
  event_start_time_is_required: "event_start_time_is_required",
  event_end_time_is_required: "event_end_time_is_required",
  competition_start_time: "competition_start_time",
  competition_start_time_is_required: "competition_start_time_is_required",
  competition_end_time_is_required: "competition_end_time_is_required",
  registration_start_date: "registration_start_date",
  registration_start_date_is_required: "registration_start_date_is_required",
  registration_end_date: "registration_end_date",
  registration_end_date_is_required: "registration_end_date_is_required",
  custom_location: "custom_location",
  maximum_participants: "maximum_participants",
  maximum_participants_allowed_is_required:
    "maximum_participants_allowed_is_required",
  user_type: "user_type",
  registration_fees: "registration_fees",
  registration_fees_is_required: "registration_fees_is_required",
  special_fee_for_members: "special_fee_for_members",
  special_fee_for_members_is_required: "special_fee_for_members_is_required",
  service_included: "service_included",
  atleast_one_service_is_required: "atleast_one_service_is_required",
  atleast_one_user_is_required: "atleast_one_user_is_required",
  upload_event_poster: "upload_event_poster",
  event_poster_is_required: "event_poster_is_required",
  upload_event_logo: "upload_event_logo",
  event_logo_is_required: "event_logo_is_required",
  leave_letters: "leave_letters",
  accommodation: "accommodation",
  flights: "flights",
  meals: "meals",
  snacks_and_water: "snacks_and_water",
  registration_end_date_cant_greater_then_event_start_date:
    "registration_end_date_cant_greater_then_event_start_date",
  services: "services",
  isMember: "isMember",
  fees: "fees",
  refundFees: "refundFees",
  refund: "refund",
  refundPercentage: "refundPercentage",
  refundAmount: "refundAmount",
  searchParticipant: "searchParticipant",
  addParticipant: "addParticipant",
  participant: "participant",
  totalPayment: "totalPayment",
  CENTER_NOT_APPROVED: "center_not_approved",
  ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_EVENT:
    "are_you_sure_you_want_to_delete_this_event",
  EVENT_UPDATED_SUCCESSFULLY: "event_updated_successfully",
  ARE_YOU_SURE_YOU_WANT_TO_CHANGE_THE_EVENT_LOCATION:
    "are_you_sure_you_want_to_change_the_event_location",
  AN_EMAIL_WILL_BE_SENT_TO_ALL_THE_REGISTERED_PARTICIPANTS:
    "an_email_will_be_sent_to_all_the_registered_participants",
  ARE_YOU_SURE_YOU_WANT_TO_CHANGE_THE_EVENT_DATES:
    "are_you_sure_you_want_to_change_the_event_dates",
  ARE_YOU_SURE_YOU_WANT_TO_CHANGE_THE_EVENT_LOCATION_TO:
    "are_you_sure_you_want_to_change_the_event_location_to",
  AN_EMAIL_WILL_BE_SENT_TO_ALL_THE_REGISTERED_PARTICIPANTS:
    "an_email_will_be_sent_to_all_the_registered_participants",
  ARE_YOU_SURE_YOU_WANT_TO_CHANGE_THE_EVENT_DATES:
    "are_you_sure_you_want_to_change_the_event_dates",
  UPCOMING: "upcoming",
  PREVIOUS: "previous",
  SHOW_PRIVATE_EVENTS: "show_private_events",
  days: "days",
  registration_ending_in: "registration_ending_in",
  registration_starts_in: "registration_starts_in",
  discount_for_members: "discount_for_members",
  registration_closed: "registration_closed",
  invite_only: "invite_only",
  EVENT_PARTICIPANT_REGISTERED_SUCCESSFULLY:
    "event_participant_registered_successfully",
  CANCEL_REGISTRATION: "cancel_registration",
  CANCEL_INVITE: "cancel_invite",
  //STUDENTS SCREEN
  LEVEL_COMPLETED: "LEVEL_COMPLETED",
  LEVEL_ACHIEVED: "LEVEL_ACHIEVED",
  ADD_STUDENT: "ADD_STUDENT",
  MY_STUDENTS: "MY_STUDENTS",
  CERTIFY_STUDENT: "CERTIFY_STUDENT",
  VIEW_CERTIFY_STUDENT: "VIEW_CERTIFY_STUDENT",
  CURRENT_LEVEL: "CURRENT_LEVEL",
  STUDENT_NAME: "STUDENT_NAME",
  STUDENT_NAME_ARABIC: "STUDENT_NAME_ARABIC",
  SPORT_TYPE: "SPORT_TYPE",
  COURSE_HOURS: "COURSE_HOURS",
  LEVEL_ASSIGNED: "LEVEL_ASSIGNED",
  REASON: "REASON",
  STUDENT_EMAIL: "STUDENT_EMAIL",
  ENTER_CURRENT_LEVEL: "ENTER_CURRENT_LEVEL",
  ENTER_STUDENT_NAME: "ENTER_STUDENT_NAME",
  ENTER_COURSE_HOURS: "ENTER_COURSE_HOURS",
  NUMBER_OF_STUDENTS: "NUMBER_OF_STUDENTS",
  NUMBER_OF_HOURS: "NUMBER_OF_HOURS",
  ENTER_ARABIC_NAME: "ENTER_ARABIC_NAME",
  DATE_ADDED: "DATE_ADDED",
  SPORT: "SPORT",
  STUDENT: "STUDENT",
  COURSE_HOURS_REQUIRED: "COURSE_HOURS_REQUIRED",
  INVALID_HOURS: "INVALID_HOURS",
  ASSIGNED_LEVEL_IS_REQUIRED: "ASSIGNED_LEVEL_IS_REQUIRED",
  INVALID_LEVEL: "INVALID_LEVEL",
  INVALID_REASON: "INVALID_REASON",
  SPORT_TYPE_IS_REQUIRED: "SPORT_TYPE_IS_REQUIRED",
  REASON_IS_REQUIRED: "REASON_IS_REQUIRED",
  INSTRUCTOR_NAME: "INSTRUCTOR_NAME",
  MY_COURSES: "MY_COURSES",
  FEEDBACK: "FEEDBACK",
  COURSE_FEEDBACK: "COURSE_FEEDBACK",
  VIEW_COURSE_FEEDBACK: "VIEW_COURSE_FEEDBACK",
  FIELD_IS_REQUIRED: "FIELD_IS_REQUIRED",
  CANCEL: "CANCEL",
  ALL_FIELDS_REQUIRED: "ALL_FIELDS_REQUIRED",
  student_not_active: "student_not_active",
  student_already_instructor_for_sport: "student_already_instructor_for_sport",
  feedback_already_submitted: "feedback_already_submitted",
  invalid_instructor_type: "invalid_instructor_type",
  center_not_approved: "center_not_approved",
  center_does_not_exist: "center_does_not_exist",
  TOTAL_SCORE: "TOTAL_SCORE",
  course_added_successfully: "course_added_successfully",
  course_feedback_added_successfully: "course_feedback_added_successfully",
  SUBSCRIPTION_SETTINGS: "SUBSCRIPTION_SETTINGS",
  VAT_PERCENTAGE: "VAT_PERCENTAGE",
  Practitioner_Membership: "Practitioner_Membership",
  YEARLY: "YEARLY",
  Membership_Fees: "Membership_Fees",
  Center_Membership: "Center_Membership",
  Freelance_Instructor: "Freelance_Instructor",
  SSF_Endorsed_yearly: "SSF_Endorsed_yearly",
  REFUND_POLICY: "REFUND_POLICY",
  REFUND_TYPE: "REFUND_TYPE",
  DAYS_PRIOR: "DAYS_PRIOR",
  DAYS: "DAYS",
  PRIOR: "PRIOR",
  refund_types_updated_successfully: "refund_types_updated_successfully",
  NO_MORE_DATA_FOUND: "no_more_data_found",
  VIEW_ALL: "view_all",
  COMPETITIONS: "competitions",
  ADD_COMPETITIONS: "ADD_COMPETITIONS",
  CREATE_A_COMPETITION: "CREATE_A_COMPETITION",
  EDIT_A_COMPETITION: "EDIT_A_COMPETITION",
  VIEW_A_COMPETITION: "VIEW_A_COMPETITION",
  COMPETITION_TITLE: "COMPETITION_TITLE",
  COMPETITION_TYPE: "COMPETITION_TYPE",
  EXCLUSIVE_FOR_MEMBERS: "EXCLUSIVE_FOR_MEMBERS",
  COMPETITION_START_DATE: "COMPETITION_START_DATE",
  COMPETITION_END_DATE: "COMPETITION_END_DATE",
  REGISTRATION_START_DATE: "REGISTRATION_START_DATE",
  REGISTRATION_END_DATE: "REGISTRATION_END_DATE",
  LOCATION_LINK: "LOCATION_LINK",
  OFFICIAL_CLASSES: "OFFICIAL_CLASSES",
  OTHER_CLASS: "OTHER_CLASS",
  REGISTRATION_FEES: "REGISTRATION_FEES",
  SPECIAL_FEES_FOR_MEMBERS: "SPECIAL_FEES_FOR_MEMBERS",
  SUGGESTED_LEVEL: "SUGGESTED_LEVEL",
  MINIMUM_AGE: "MINIMUM_AGE",
  MAXIMUM_AGE: "MAXIMUM_AGE",
  SERVICES_INCLUDED: "SERVICES_INCLUDED",
  UPLOAD_NOR: "UPLOAD_NOR",
  UPLOAD_COMPETITION_POSTER: "UPLOAD_COMPETITION_POSTER",
  UPLOAD_COMPETITION_LOGO: "UPLOAD_COMPETITION_LOGO",
  LEVEL_1: "LEVEL_1",
  LEVEL_2: "LEVEL_2",
  LEVEL_3: "LEVEL_3",
  LEAVE_LETTER: "LEAVE_LETTER",
  MEALS: "MEALS",
  FLIGHTS: "FLIGHTS",
  RENTED_BOATS: "RENTED_BOATS",
  ACCOMMODATION: "ACCOMMODATION",
  SNACKS_AND_WATER: "SNACKS_AND_WATER",
  BOATS_FOR_PARTICIPANTS: "BOATS_FOR_PARTICIPANTS",
  ENTER_COMPETITION_TITLE: "ENTER_COMPETITION_TITLE",
  ENTER_COMPETITION_DESCRIPTION: "ENTER_COMPETITION_DESCRIPTION",
  ENTER_COMPETITION_REGISTRATION_FEE: "ENTER_COMPETITION_REGISTRATION_FEE",
  ENTER_COMPETITION_SPECIAL_FEES_FOR_MEMBERS:
    "ENTER_COMPETITION_SPECIAL_FEES_FOR_MEMBERS",
  ENTER_COMPETITION_MIN_AGE: "ENTER_COMPETITION_MIN_AGE",
  ENTER_COMPETITION_MAX_AGE: "ENTER_COMPETITION_MAX_AGE",
  ENTER_COMPETITION_OTHER_CLASS: "ENTER_COMPETITION_OTHER_CLASS",
  SELECT_COMPETITION_SUGGESTED_LEVEL: "SELECT_COMPETITION_SUGGESTED_LEVEL",
  SELECT_COMPETITION_SPORT_TYPE: "SELECT_COMPETITION_SPORT_TYPE",
  SELECT_COMPETITION_LOCATION: "SELECT_COMPETITION_LOCATION",
  SELECT_COMPETITION_OFFICIAL_CLASSES: "SELECT_COMPETITION_OFFICIAL_CLASSES",
  COMPETITION_TITLE_REQUIRED: "COMPETITION_TITLE_REQUIRED",
  COMPETITION_TITLE_TOO_LONG: "COMPETITION_TITLE_TOO_LONG",
  COMPETITION_ARABIC_TITLE_REQUIRED: "COMPETITION_ARABIC_TITLE_REQUIRED",
  COMPETITION_ARABIC_TITLE_TOO_LONG: "COMPETITION_ARABIC_TITLE_TOO_LONG",
  INVALID_COMETITION_TITLE: "INVALID_COMETITION_TITLE",
  COMPETITION_DESCRIPTION_REQUIRED: "COMPETITION_DESCRIPTION_REQUIRED",
  COMPETITION_DESCRIPTION_TOO_LONG: "COMPETITION_DESCRIPTION_TOO_LONG",
  COMPETITION_ARABIC_DESCRIPTION_TOO_LONG:
    "COMPETITION_ARABIC_DESCRIPTION_TOO_LONG",
  COMPETITION_TYPE_REQUIRED: "COMPETITION_TYPE_REQUIRED",
  COMPETITION_EXCLUSIVE_MEMBERS_REQUIRED:
    "COMPETITION_EXCLUSIVE_MEMBERS_REQUIRED",
  COMPETITION_START_DATE_REQUIRED: "COMPETITION_START_DATE_REQUIRED",
  COMPETITION_END_DATE_REQUIRED: "COMPETITION_END_DATE_REQUIRED",
  COMPETITION_REGISTRATION_START_DATE_REQUIRED:
    "COMPETITION_REGISTRATION_START_DATE_REQUIRED",
  COMPETITION_REGISTRATION_END_DATE_REQUIRED:
    "COMPETITION_REGISTRATION_END_DATE_REQUIRED",
  COMPETITION_LOCATION_REQUIRED: "COMPETITION_LOCATION_REQUIRED",
  COMPETITION_LOCATION_LINK_REQUIRED: "COMPETITION_LOCATION_LINK_REQUIRED",
  COMPETITION_SPORT_TYPE_REQUIRED: "COMPETITION_SPORT_TYPE_REQUIRED",
  COMPETITION_OFFICIAL_CLASSES_REQUIRED:
    "COMPETITION_OFFICIAL_CLASSES_REQUIRED",
  COMPETITION_OTHER_CLASS_REQUIRED: "COMPETITION_OTHER_CLASS_REQUIRED",
  COMPETITION_REGISTRATION_FEE_REQUIRED:
    "COMPETITION_REGISTRATION_FEE_REQUIRED",
  COMPETITION_SPECIAL_FEE_REQUIRED: "COMPETITION_SPECIAL_FEE_REQUIRED",
  COMPETITION_SUGGESTED_LEVEL_REQUIRED: "COMPETITION_SUGGESTED_LEVEL_REQUIRED",
  COMPETITION_MIN_AGE_REQUIRED: "COMPETITION_MIN_AGE_REQUIRED",
  COMPETITION_MAX_AGE_REQUIRED: "COMPETITION_MAX_AGE_REQUIRED",
  COMPETITION_MAX_AGE_VALIDATION: "COMPETITION_MAX_AGE_VALIDATION",
  COMPETITION_NOR_REQUIRED: "COMPETITION_NOR_REQUIRED",
  COMPETITION_POSTERS_REQUIRED: "COMPETITION_POSTERS_REQUIRED",
  COMPETITION_LOGO_REQUIRED: "COMPETITION_LOGO_REQUIRED",
  COMPETITION_START_DATE_CANNOT_BE_PAST:
    "COMPETITION_START_DATE_CANNOT_BE_PAST",
  COMPETITION_END_DATE_MUST_BE_AFTER_START_DATE:
    "COMPETITION_END_DATE_MUST_BE_AFTER_START_DATE",
  REGISTRATION_START_DATE_MUST_BE_BEFORE_START_DATE:
    "REGISTRATION_START_DATE_MUST_BE_BEFORE_START_DATE",
  REGISTRATION_START_DATE_CANNOT_BE_PAST:
    "REGISTRATION_START_DATE_CANNOT_BE_PAST",
  REGISTRATION_END_DATE_MUST_BE_BEFORE_START_DATE:
    "REGISTRATION_END_DATE_MUST_BE_BEFORE_START_DATE",
  REGISTRATION_END_DATE_MUST_BE_AFTER_REGISTRATION_START_DATE:
    "REGISTRATION_END_DATE_MUST_BE_AFTER_REGISTRATION_START_DATE",
  TITLE: "TITLE",
  START_DATE: "START_DATE",
  END_DATE: "END_DATE",
  CLASS_OF_BOAT: "CLASS_OF_BOAT",
  ACTIONS: "ACTIONS",
  FROM_COMPETITION_LIST: "FROM_COMPETITION_LIST",
  COMPETITION_DELETE: "COMPETITION_DELETE",
  ARE_YOU_SURE_YOU_WANT_TO_CHANGE_THE: "ARE_YOU_SURE_YOU_WANT_TO_CHANGE_THE",
  COMPETITION_LOCATION: "COMPETITION_LOCATION",
  DATES: "DATES",
  COMPETITION_LOCAITON_AND_DATE: "COMPETITION_LOCAITON_AND_DATE",
  EMAIL_TO_ALL_PARTICIPANTS: "EMAIL_TO_ALL_PARTICIPANTS",
  CHANGE: "CHANGE",
  EVENT_PARTICIPANT_ALREADY_EXISTS: "event_participant_already_exists",
  CANCELED: "canceled",
  SHOW_PRIVATE_COMPETITIONS: "SHOW_PRIVATE_COMPETITIONS",
  DISCOUNT_FOR_SSF_MEMBERS: "DISCOUNT_FOR_SSF_MEMBERS",
  REGISTER_NOW: "REGISTER_NOW",
  INVITE_ONLY: "INVITE_ONLY",
  REGISTRATION_CLOSED: "REGISTRATION_CLOSED",
  REGISTRATION_STRING_OPEN: "REGISTRATION_STRING_OPEN",
  REGISTRATION_STRING_CLOSED: "REGISTRATION_STRING_CLOSED",
  VIEW_RESULT: "VIEW_RESULT",
  SAILING_PUBLIC_SPOT: "SAILING_PUBLIC_SPOT",
  AGE_LIMIT: "AGE_LIMIT",
  SERVICES: "SERVICES",
  YEARS: "YEARS",
  NOTICE_OF_RACE: "NOTICE_OF_RACE",
  VIEW_CANCELLATION_POLICY: "VIEW_CANCELLATION_POLICY",
  CANCEL_COMPETITION_REGISTRATION: "CANCEL_COMPETITION_REGISTRATION",
  ARE_YOU_SURE_WANT_TO_CANCEL: "ARE_YOU_SURE_WANT_TO_CANCEL",
  REGISTRATION: "REGISTRATION",
  PARTICIPANTS_TAB: "PARTICIPANTS_TAB",
  IS_MEMBER: "IS_MEMBER",
  FEES: "FEES",
  REFUND: "REFUND",
  ADD_PARTICIPANTS: "ADD_PARTICIPANTS",
  TOTAL_PAYMENT: "TOTAL_PAYMENT",
  UPDATE_SCORE: "UPDATE_SCORE",
  SCORE: "SCORE",
  RANKING: "RANKING",
  PUBLISH_SCORE: "PUBLISH_SCORE",
  UPLOAD_RESULTS: "UPLOAD_RESULTS",
  PUBLISH_SCORE_TEXT: "PUBLISH_SCORE_TEXT",
  PUBLISH_SCORE_TITLE: "PUBLISH_SCORE_TITLE",
  SAVE_SCORE_TEXT: "SAVE_SCORE_TEXT",
  SAVE_SCORE_TITLE: "SAVE_SCORE_TITLE",
  SEARCH_PRACTITIONER: "SEARCH_PRACTITIONER",
  ADD_PRACTITIONER: "ADD_PRACTITIONER",
  PRACTITIONER_LEVEL: "PRACTITIONER_LEVEL",
  ENTER_REFUND_PERCENTAGE: "ENTER_REFUND_PERCENTAGE",
  ENTER_REFUND_AMOUNT: "ENTER_REFUND_AMOUNT",
  ENTER_COMMENTS: "ENTER_COMMENTS",
  REFUND_FEES: "REFUND_FEES",
  REFUND_AMOUNT: "REFUND_AMOUNT",
  REFUND_PERCENTAGE: "REFUND_PERCENTAGE",
  SAVE: "SAVE",
  UPLOAD_RESULT_DOCUMENT: "UPLOAD_RESULT_DOCUMENT",
  ENTER_THE_RESULT_LINK: "ENTER_THE_RESULT_LINK",
  UPDATE_COMPETITION_SCORE: "UPDATE_COMPETITION_SCORE",
  URL_IS_REQUIRED: "URL_IS_REQUIRED",
  FILE_IS_REQUIRED: "FILE_IS_REQUIRED",
  ARE_YOU_SURE_YOU_WANT_TO_CANCEL_REGISTRATION:
    "are_you_sure_you_want_to_cancel_registration",
  REGISTER_FOR_EVENT: "register_for_event",
  SCORE_NOT_PUBLISHED: "SCORE_NOT_PUBLISHED",
  SSF_CALENDER: "ssf_calender",
  INVALID_VALUE: "INVALID_VALUE",
  REGISTER_FOR_COMPETITION: "REGISTER_FOR_COMPETITION",
  VIEW_DETAILS_RESULT: "VIEW_DETAILS_RESULT",
  PAYABLE_AMOUNT: "PAYABLE_AMOUNT",
  PAYMENT_METHOD: "PAYMENT_METHOD",
  VAT_INCLUDED: "VAT_INCLUDED",
  USE_SAVED_CARD: "USE_SAVED_CARD",
  USE_NEW_CARD: "USE_NEW_CARD",
  AGREE_TO_COMPETITION_TERMS: "AGREE_TO_COMPETITION_TERMS",
  COMPETITION_FEEDBACK: "COMPETITION_FEEDBACK",
  THIS_FIELD_IS_REQUIRED: "THIS_FIELD_IS_REQUIRED",
  VALUE_CANNOT_BE_NEGATIVE: "VALUE_CANNOT_BE_NEGATIVE",
  CANCELLED: "CANCELLED",
  OUR_SPONSERS: "OUR_SPONSERS",
  SEARCH_ANY_KEYWORD: "SEARCH_ANY_KEYWORD",
  SELECT_BOAT_CLASS: "SELECT_BOAT_CLASS",
  SELECT_YEAR: "SELECT_YEAR",
  INCLUDED: "included",
  MAXIMUM_PARTICIPANTS_MUST_BE_GREATER_THAN_0:
    "maximum_participants_must_be_greater_than_0",
  MUST_BE_NON_NEGATIVE: "must_be_non_negative",
  MUST_BE_100_OR_LESS: "must_be_100_or_less",
  CONFIRMATION: "confirmaton",
  SAILOR_NOT_FOUND: "sailor_not_found",
  ADD_EVENT: "ADD_EVENT",
  DELETE_A_EVENT: "DELETE_A_EVENT",
  SEATS_AVAILABLE: "SEATS_AVAILABLE",
  CONFIRMATION: "confirmaton",
  SAILOR_NOT_FOUND: "sailor_not_found",
  EVENT_REGULATIONS: "EVENT_REGULATIONS",
  COMPETITIONS_REGULATIONS: "COMPETITIONS_REGULATIONS",
  EDIT_AN_EVENT: "EDIT_AN_EVENT",
  EVENT_DESCRIPTION_TOO_LONG: "EVENT_DESCRIPTION_TOO_LONG",
  EVENT_ARABIC_DESCRIPTION_TOO_LONG: "EVENT_ARABIC_DESCRIPTION_TOO_LONG",
  MY_EVENTS: "MY_EVENTS",
  INVALID_STUDENT_EMAIL: "INVALID_STUDENT_EMAIL",
  STUDENT_EMAIL_IS_REQUIRED: "STUDENT_EMAIL_IS_REQUIRED",
  ARABIC_WITH_BRACES: "ARABIC_WITH_BRACES",
  SAR_WITH_BRACES: "SAR_WITH_BRACES",
  VIEW_MORE: "view_more",
  SEARCH_FIELD_NOT_EMPTY: "SEARCH_FIELD_NOT_EMPTY",
  SAILOR_NOT_FOUND: "SAILOR_NOT_FOUND",
  INVALID_AMOUNT: "invalid_amount",
  SHOW_ALL_EVENTS: "show_all_events",
  PUBLIC_EVENTS: "public_events",
  PRIVATE_EVENTS: "private_events",
  SHOW_ALL_COMPETITIONS: "show_all_competitions",
  PUBLIC_COMPETITIONS: "public_competitions",
  PRIVATE_COMPETITIONS: "private_competitions",
  SELECT_SPOT_TYPE: "select_spot_type",
  SELECT_SPOT_TYPE: "select_spot_type",
  Select: "Select",
  MAX_HOURS_LENGHT_INVALID: "MAX_HOURS_LENGHT_INVALID",
  EVENT_POSTER_REQUIRED: "EVENT_POSTER_REQUIRED",
  EVENT_LOGO_REQUIRED: "EVENT_LOGO_REQUIRED",
  EVENT_DESCRIPTION_REQUIRED: "EVENT_DESCRIPTION_REQUIRED",
  COMPETITION_SPECIAL_FEE_VALIDATION: "COMPETITION_SPECIAL_FEE_VALIDATION",
  INVALID_AMOUNT: "invalid_amount",
  POINTS: "POINTS",
  practioner: "practioner",
  THE_LOCATION_PINS_SHOWN_ON_MAP_ARE_ONLY_APPROVED_LOCATIONS:
    "the_location_pins_shown_on_map_are_only_approved_locations",
  CLEAR_FILTERS: "clear_filters",
  RESET_FIILTERS: "reset_filters",
  practioner: "practioner",
  RECAPTCHA_NOT_EXECUTED: "RECAPTCHA_NOT_EXECUTED",
  RECAPTCHA_ERROR: "RECAPTCHA_ERROR",
  EVENT: "EVENT",
  COMPETITION: "COMPETITION",
  CENTER_ACTIVITY_CALENDER: "CENTER_ACTIVITY_CALENDER",
  FEEDBACK_SCORE: "FEEDBACK_SCORE",
  TOTAL_REVIEW_SCORE: "TOTAL_REVIEW_SCORE",
  PLEASE_SELECT_A_PRIMARY_LOCATION: "PLEASE_SELECT_A_PRIMARY_LOCATION",
  NO_COMMON_SPORTS_FOUND: "NO_COMMON_SPORTS_FOUND",
  VAT_NO: "VAT_NO",
  SELECT_ACTIVITY_STATUS: "SELECT_ACTIVITY_STATUS",
  LOCATION_NAME: "LOCATION_NAME",
  DISABLE_USER: "DISABLE_USER",
  DISABLE_INSTRUCTOR: "DISABLE_INSTRUCTOR",
  YOU_ARE_GOING_TO_DISABLE_USER: "YOU_ARE_GOING_TO_DISABLE_USER",
  PLEASE_COMMENT_DOWN_A_REASON_BELOW: "PLEASE_COMMENT_DOWN_A_REASON_BELOW",
  COMPETITION_IN_PROGRESS: "COMPETITION_IN_PROGRESS",
  EVENT_IN_PROGRESS: "EVENT_IN_PROGRESS",
  SELECT_UNOFFICIAL_CLASSES: "SELECT_UNOFFICIAL_CLASSES",
  SELECT_OFFICIAL_CLASSES: "SELECT_OFFICIAL_CLASSES",
  centerNameArabic: "center_name_arabic",
  USER_INELIGIBLE: "user_ineligible",
  DISABLE_SPOT: "DISABLE_SPOT",
  YOU_ARE_GOING_TO_DISABLE_SPOT: "YOU_ARE_GOING_TO_DISABLE_SPOT",
  ARE_YOU_SURE_WANT_TO_DISABLE_SPOT: "ARE_YOU_SURE_WANT_TO_DISABLE_SPOT",
  ACTIVATE_SPOT: "ACTIVATE_SPOT",
  YOU_ARE_GOING_TO_ACTIVATE_SPOT: "YOU_ARE_GOING_TO_ACTIVATE_SPOT",
  ARE_YOU_SURE_WANT_TO_ACTIVATE_SPOT: "ARE_YOU_SURE_WANT_TO_ACTIVATE_SPOT",
  COMPETITON_REQUIRES_ATLEAST_ONE_USER_IS_REQUIRED:
    "COMPETITON_REQUIRES_ATLEAST_ONE_USER_IS_REQUIRED",
  USER_ALLOWED: "USER_ALLOWED",
  ACTIVITY_POSTER_REQUIRED: "ACTIVITY_POSTER_REQUIRED",
  ACTIVITY_LOGO_REQUIRED: "ACTIVITY_LOGO_REQUIRED",
  POSTER_RECOMMENDED_SIZE: "POSTER_RECOMMENDED_SIZE",
  URL_VALIDATION: "URL_VALIDATION",
  OUT_OF: "OUT_OF",
  COMPETITION_MAX_PARTICIPANT: "COMPETITION_MAX_PARTICIPANT",
  COMPETITION_MAX_PARTICIPANTS_ALLOWED: "COMPETITION_MAX_PARTICIPANTS_ALLOWED",
  COMPETITION_MAX_PARTICIPANTS_REQUIRED:
    "COMPETITION_MAX_PARTICIPANTS_REQUIRED",
  COMPETITION_MAX_PARTICIPANTS_MAX_LIMIT:
    "COMPETITION_MAX_PARTICIPANTS_MAX_LIMIT",
  Center_Pending: "Center_Pending",
  Nafes_Pending: "Nafes_Pending",
  Spot_Pending: "Spot_Pending",
  Applied_For: "Applied_For",
  Nafes: "Nafes",
  Spot: "Spot",
  Center: "Center",
  STUDENT_EMAIL: "STUDENT_EMAIL",
  BECOME_A_MEMBER: "BECOME_A_MEMBER",
  YEARLY_WITH_BRACKETS: "YEARLY_WITH_BRACKETS",
  NEXT_PAYMENT_DUE_DATE: "NEXT_PAYMENT_DUE_DATE",
  IS_MEMEBR: "IS_MEMEBR",
  MEMBER: "MEMBER",
  ADMIN_PAYMENT_HISTORY: "ADMIN_PAYMENT_HISTORY",
  TIMESTAMP: "TIMESTAMP",
  USERNAME: "USERNAME",
  CARD_TYPE: "CARD_TYPE",
  CARD_NUMBER: "CARD_NUMBER",
  PAYMENT_TYPE: "PAYMENT_TYPE",
  UNKNOWN: "UNKNOWN",
  SSF_PAYMENT_MEMBERSHIP: "SSF_PAYMENT_MEMBERSHIP",
  SSF_PAYMENT_EVENT_REGISTRATION: "SSF_PAYMENT_EVENT_REGISTRATION",
  SSF_PAYMENT_COMPETITION_REGISTRATION: "SSF_PAYMENT_COMPETITION_REGISTRATION",
  SSF_PAYMENT_CENTER: "SSF_PAYMENT_CENTER",
  SSF_PAYMENT_FREELANCE: "SSF_PAYMENT_FREELANCE",
  SSF_PAYMENT_ADDON: "SSF_PAYMENT_ADDON",
  SAVE_CARD_DETAIL: "SAVE_CARD_DETAIL",
  PAY_NOW: "PAY_NOW",
  CARD_HOLDER_NAME: "CARD_HOLDER_NAME",
  SECURED_BY_HYPERPAY: "SECURED_BY_HYPERPAY",
  PAYMENT_REGULATIONS: "PAYMENT_REGULATIONS",
  AGREE_TO_TERMS: "AGREE_TO_TERMS",
  SELECT_CARD: "SELECT_CARD",
  PLEASE_SELECT_A_CARD: "PLEASE_SELECT_A_CARD",
  PAYMNET_REGULATION_REQUIRED: "PAYMNET_REGULATION_REQUIRED",
  PAYMENT_CARD_IS_REQUIRED: "PAYMENT_CARD_IS_REQUIRED",
  DEFAULT: "DEFAULT",
  INVALID_TOTAL_AMOUNT: "INVALID_TOTAL_AMOUNT",
  important_documents: "important_documents",
  competition_is_ended: "competition_is_ended",
  are_you_sure_you_want_to_update: "are_you_sure_you_want_to_update",
  add_to_calendar: "add_to_calendar",

  sailor_not_found: "sailor_not_found",
  competition_type_private_registration_not_allowed:
    "competition_type_private_registration_not_allowed",
  competition_participants_score_pending:
    "competition_participants_score_pending",
  competition_not_published: "competition_not_published",
  event_not_published: "event_not_published",
  participant_does_not_exist: "participant_does_not_exist",
  invalid_checkout: "invalid_checkout",
  approved_payment_not_found: "approved_payment_not_found",
  invalid_checkout_type: "invalid_checkout_type",
  payment_unsuccessful: "payment_unsuccessful",
  registration_unsuccessful: "registration_unsuccessful",
  checkout_unsuccessful: "checkout_unsuccessful",
  center_payment_sucessful: "center_payment_sucessful",
  default_card_not_found: "default_card_not_found",
  card_saved_successfully: "card_saved_successfully",
  card_updated_successfully: "card_updated_successfully",
  card_not_found: "card_not_found",
  only_one_card_found: "only_one_card_found",
  INVALID_CARD_HOLDER: "INVALID_CARD_HOLDER",
  user_membership_updated_successfully: "user_membership_updated_successfully",
  INVALID_USER: "INVALID_USER",
  registration_starting_tomorrow: "registration_starting_tomorrow",
  registration_starting_today: "registration_starting_today",
  registration_ending_tomorrow: "registration_ending_tomorrow",
  registration_ending_today: "registration_ending_today",
  Affiliated_Center: "Affiliated_Center",
  TEACHING_LOCATION: "TEACHING_LOCATION",
  SPORTS_OFFERED_WITH_BRACKETS: "SPORTS_OFFERED_WITH_BRACKETS",
  YOUR_ANNUAL_PAYMENT_FOR_FREELANCE_SUBSCRIPTION_WAS_DECLINED:
    "YOUR_ANNUAL_PAYMENT_FOR_FREELANCE_SUBSCRIPTION_WAS_DECLINED",
  CLICK_HERE_TO_RENEW: "CLICK_HERE_TO_RENEW",
  PAY: "PAY",
  YOUR_ANNUAL_PAYMENT_FOR_CENTER_SUBSCRIPTION_WAS_DECLINED:
    "YOUR_ANNUAL_PAYMENT_FOR_CENTER_SUBSCRIPTION_WAS_DECLINED",
  RESEND_REQUEST: "RESEND_REQUEST",
  RESEND_REQUEST_FOR_CENTER_APPROVAL: "RESEND_REQUEST_FOR_CENTER_APPROVAL",
  GENERAL_TRAINING: "GENERAL_TRAINING",
  SELECT_INSTRUCTOR: "SELECT_INSTRUCTOR",
  INSTRUCTOR_REQUIRED: "INSTRUCTOR_REQUIRED",
  INVALID_INSTRUCTOR: "INVALID_INSTRUCTOR",
  registration_starts_in: "registration_starts_in",
  days: "days",
  registration_ending_in: "registration_ending_in",
  RESTRICTED: "RESTRICTED",
  EVENT_FEE: "EVENT_FEE",
  COMPETITION_FEE: "COMPETITION_FEE",
  AUDIT_LOGS: "AUDIT_LOGS",
  MODULE: "MODULE",
  ACTION: "ACTION",
  OLD_VALUE: "OLD_VALUE",
  NEW_VALUE: "NEW_VALUE",
  CHANGED_BY: "CHANGED_BY",
  INSTRUCTORS_SCREEN: "INSTRUCTORS_SCREEN",
  USERS_SCREEN: "USERS_SCREEN",
  CENTERS_SCREEN: "CENTERS_SCREEN",
  COURSES_SCREEN: "COURSES_SCREEN",
  EVENTS_SCREEN: "EVENTS_SCREEN",
  COMPETITIONS_SCREEN: "COMPETITIONS_SCREEN",
  SPOTS_SCREEN: "SPOTS_SCREEN",
  SUBSCRIPTION_SETTINGS_SCREEN: "SUBSCRIPTION_SETTINGS_SCREEN",
  ADMIN_USERS_SCREEN: "ADMIN_USERS_SCREEN",
  REFUND_POLICY_SCREEN: "REFUND_POLICY_SCREEN",
  ADMIN_PAYMENT_HISTORY_SCREEN: "ADMIN_PAYMENT_HISTORY_SCREEN",
  ADMIN_AUDIT_LOGS_SCREEN: "ADMIN_AUDIT_LOGS_SCREEN",
  Create: "Create",
  Delete: "Delete",
  PLEASE_CONTACT_US_AT: "PLEASE_CONTACT_US_AT",
  SAILOR: "SAILOR",
  EXCLUDED: "EXCLUDED",
  PRIVATE_EVENT: "PRIVATE_EVENT",
  REFUNDED: "REFUNDED",
  ADDON_TYPE: "ADDON_TYPE",
  SSF_PAYMENT_CENTER_SPOT_ADDON: "SSF_PAYMENT_CENTER_SPOT_ADDON",
  SSF_PAYMENT_CENTER_SPOT_SPORT_ADDON: "SSF_PAYMENT_CENTER_SPOT_SPORT_ADDON",
  SSF_PAYMENT_FREELANCE_SPORT_ADDON: "SSF_PAYMENT_FREELANCE_SPORT_ADDON",
  RECORD_ID: "RECORD_ID",
  COPY_TO_CLIPBOARD: "COPY_TO_CLIPBOARD",
  ID: "ID",
  UPDATE_FREELANCE_INSTRUCTOR: "UPDATE_FREELANCE_INSTRUCTOR",
  CURRENT_SPORTS: "CURRENT_SPORTS",
  PAYABLE_NOW: "PAYABLE_NOW",
  AUTO_PAYMENT_FOR_NEW_SPORTS_AND_REMAINING_DURATION:
    "AUTO_PAYMENT_FOR_NEW_SPORTS_AND_REMAINING_DURATION",
  SELECTED_SPOT_LACKS_YOUR_SPORTS: "SELECTED_SPOT_LACKS_YOUR_SPORTS",
  FREELANCE_INSTRUCTOR_PAYMENT: "FREELANCE_INSTRUCTOR_PAYMENT",
  DAYSLEFT: "DAYSLEFT",
  STARTING_TODAY: "STARTING_TODAY",
  EVENT_ARABIC_TITLE_TOO_LONG: "EVENT_ARABIC_TITLE_TOO_LONG",
  EVENT_TITLE_TOO_LONG: "EVENT_TITLE_TOO_LONG",
  PLEASE_SELECT_COUNTRY: "PLEASE_SELECT_COUNTRY",
  NO_EXPIRY_DATE: "NO_EXPIRY_DATE",
  TIMEZONE_DISPLAY_ON_GRID: "TIMEZONE_DISPLAY_ON_GRID",
  TIMEZONE_DISPLAY_ON_FIELD: "TIMEZONE_DISPLAY_ON_FIELD",
  ADDITIONAL_INFO_VALUES: "ADDITIONAL_INFO_VALUES",
  INDIVIDUAL: "INDIVIDUAL",
  HEAD_INSTRUCTOR_NAME: "HEAD_INSTRUCTOR_NAME",
  HEAD_INSTRUCTOR_EMAIL: "HEAD_INSTRUCTOR_EMAIL",
  UPLOAD_HEAD_INSTRUCTOR_CERTIFICATE: "UPLOAD_HEAD_INSTRUCTOR_CERTIFICATE",
  ENTER_HEAD_INSTRUCTOR_NAME: "ENTER_HEAD_INSTRUCTOR_NAME",
  HEAD_INSTRUCTOR_NAME_REQUIRED: "HEAD_INSTRUCTOR_NAME_REQUIRED",
  INVALID_HEAD_INSTRUCTOR_NAME: "INVALID_HEAD_INSTRUCTOR_NAME",
  BLOOD_GROUP: "BLOOD_GROUP",
  SELECT_BLOOD_GROUP: "SELECT_BLOOD_GROUP",
  BLOOD_GROUP_REQUIRED: "BLOOD_GROUP_REQUIRED",
  INVITE_HEAD_INSTRUCTOR: "INVITE_HEAD_INSTRUCTOR",
  BOAT_TYPE: "BOAT_TYPE",
  BOAT_CLASS: "BOAT_CLASS",
  BOAT_CLASSES: "BOAT_CLASSES",
  ADD_CLASS: "ADD_CLASS",
  ADD_BOAT_CLASS: "ADD_BOAT_CLASS",
  EDIT_BOAT_CLASS: "EDIT_BOAT_CLASS",
  VIEW_BOAT_CLASS: "VIEW_BOAT_CLASS",
  BOAT_CLASS_NAME: "BOAT_CLASS_NAME",
  ENTER_BOAT_CLASS_NAME: "ENTER_BOAT_CLASS_NAME",
  BOAT_CLASS_NAME_REQUIRED: "BOAT_CLASS_NAME_REQUIRED",
  BOAT_CLASS_NAME_TOO_LONG: "BOAT_CLASS_NAME_TOO_LONG",
  INVALID_BOAT_NAME: "INVALID_BOAT_NAME",
  BOAT_CLASS_ARABIC_NAME_TOO_LONG: "BOAT_CLASS_ARABIC_NAME_TOO_LONG",
  BOAT_CLASS_ARABIC_NAME_REQUIRED: "BOAT_CLASS_ARABIC_NAME_REQUIRED",
  INVALID_BOAT_CLASS_ARABIC_NAME: "INVALID_BOAT_CLASS_ARABIC_NAME",
  CLASS_DESCRIPTION: "CLASS_DESCRIPTION",
  ENTER_CLASS_DESCRIPTION: "ENTER_CLASS_DESCRIPTION",
  CLASS_DESCRIPTION_REQUIRED: "CLASS_DESCRIPTION_REQUIRED",
  CLASS_ARABIC_DESCRIPTION_REQUIRED: "CLASS_ARABIC_DESCRIPTION_REQUIRED",
  SELECT_SPORT_TYPE: "SELECT_SPORT_TYPE",
  BOAT_TYPE_REQUIRED: "BOAT_TYPE_REQUIRED",
  SELECT_BOAT_TYPE: "SELECT_BOAT_TYPE",
  MIXED: "MIXED",
  BOTH: "BOTH",
  BOAT_CLASS_REQUIRED_ATLEAST_ONE_GENDER:
    "BOAT_CLASS_REQUIRED_ATLEAST_ONE_GENDER",
  DINGHY: "DINGHY",
  KEELBOAT: "KEELBOAT",
  MULTI_HULL: "MULTI_HULL",
  YACHT: "YACHT",
  FORMULA_KITE: "FORMULA_KITE",
  KITE_BOARDER: "KITE_BOARDER",
  IQFOIL: "IQFOIL",
  WIND_SURFER: "WIND_SURFER",
  FORMULA_WING: "FORMULA_WING",
  WING_FOILER: "WING_FOILER",
  AMATEUR: "AMATEUR",
  RACER: "RACER",
  ELITE: "ELITE",
  BEGINNER: "BEGINNER",
  INTERMEDIATE: "INTERMEDIATE",
  ADVANCED: "ADVANCED",
  DELETE_A_BOAT_CLASS: "DELETE_A_BOAT_CLASS",
  FROM_BOAT_CLASS_LIST: "FROM_BOAT_CLASS_LIST",
  DATE_OF_COMPLETION: "DATE_OF_COMPLETION",
  DATE_OF_COMPLETION_REQUIRED: "DATE_OF_COMPLETION_REQUIRED",
  SUGGESTED_PROFICIENCY_LEVEL: "SUGGESTED_PROFICIENCY_LEVEL",
  SUGGESTED_PROFICIENCY_LEVEL_REQUIRED: "SUGGESTED_PROFICIENCY_LEVEL_REQUIRED",
  ATTACHMENTS: "ATTACHMENTS",
  SELECT_PROFICIENCY_LEVEL: "SELECT_PROFICIENCY_LEVEL",
  SELECT_LEVEL: "SELECT_LEVEL",
  SUGGESTED_LEVEL_REQUIRED: "SUGGESTED_LEVEL_REQUIRED",
  COMPLETION_DATE: "COMPLETION_DATE",
  QUALIFICATION_ALREADY_EXIST: "QUALIFICATION_ALREADY_EXIST",
  PENDING_APPROVAL: "PENDING_APPROVAL",
  PROFICIENCY_LEVEL: "PROFICIENCY_LEVEL",
  APPROVE_CERTIFICATE: "APPROVE_CERTIFICATE",
  ASSIGN_A_LEVEL: "ASSIGN_A_LEVEL",
  ASSIGN_PROFICIENCY_LEVEL: "ASSIGN_PROFICIENCY_LEVEL",
  REJECT_DOCUMENT: "REJECT_DOCUMENT",
  INVALID_BOAT_TYPE: "INVALID_BOAT_TYPE",
  PROFICIENCY_LEVEL_ASSIGNED: "PROFICIENCY_LEVEL_ASSIGNED",
  ASSIGNED_PROFICIENCY_LEVEL_IS_REQUIRED:
    "ASSIGNED_PROFICIENCY_LEVEL_IS_REQUIRED",
  INVALID_PROFICIENCY_LEVEL: "INVALID_PROFICIENCY_LEVEL",
  INVALID_SPORT_TYPE: "INVALID_SPORT_TYPE",
  SELECT_A_CITY: "SELECT_A_CITY",
  SELECT_BOAT_CLASSES: "SELECT_BOAT_CLASSES",
  COMPETITION_BOAT_CLASSES_REQUIRED: "COMPETITION_BOAT_CLASSES_REQUIRED",
  CHOOSE_BOAT_CLASS_FOR_COMPETITION: "CHOOSE_BOAT_CLASS_FOR_COMPETITION",
  COMPETITION_BOAT_CLASS_REQUIRED: "COMPETITION_BOAT_CLASS_REQUIRED",
  SELECT_BOAT_CLASSS: "SELECT_BOAT_CLASSS",
  USER_INELIGIBLE_BECAUSE_NO_BOAT_CLASS_AVAILABLE:
    "USER_INELIGIBLE_BECAUSE_NO_BOAT_CLASS_AVAILABLE",
  ALL_BOAT_CLASS: "ALL_BOAT_CLASS",
  OVERALL: "OVERALL",
  YOUTH_ONLY: "YOUTH_ONLY",
  NO_OPTION_AVAILABLE: "NO_OPTION_AVAILABLE",
  HEAD_INSTRUCTOR_DETAILS: "HEAD_INSTRUCTOR_DETAILS",
  UPDATE_INSTRUCTOR: "UPDATE_INSTRUCTOR",
  PAYMENT: "PAYMENT",
  FREELANCE_INFORMATION: "FREELANCE_INFORMATION",
  EVENT_SPORT_TYPE_REQUIRED: "EVENT_SPORT_TYPE_REQUIRED",
  PAYMENT_INVOICE_LINKS: "PAYMENT_INVOICE_LINKS",
  INVOICE_LINK: "INVOICE_LINK",
  NO_INVOICE_LINK_AVAILABLE: "NO_INVOICE_LINK_AVAILABLE",
  CREDIT_NOTE_LINK: "CREDIT_NOTE_LINK",
  NO_CREDIT_NOTE_LINK_AVAILABLE: "NO_CREDIT_NOTE_LINK_AVAILABLE",
  CENTER_ADDRESS: "CENTER_ADDRESS",
  ENTER_CENTER_ADDRESS: "ENTER_CENTER_ADDRESS",
  CENTER_ADDRESS_REQUIRED: "CENTER_ADDRESS_REQUIRED",
  CENTER_TAX_NUMBER: "CENTER_TAX_NUMBER",
  ENTER_CENTER_TAX_NUMBER: "ENTER_CENTER_TAX_NUMBER",
  CENTER_TAX_NUMBER_REQUIRED: "CENTER_TAX_NUMBER_REQUIRED",
  CENTER_TAX_NUMBER_NUMERIC_ONLY: "CENTER_TAX_NUMBER_NUMERIC_ONLY",
  SEARCH_SAILOR: "SEARCH_SAILOR",
  SAILOR_LEVEL: "SAILOR_LEVEL",
  CLICK_HERE_TO_DOWNLOAD: "CLICK_HERE_TO_DOWNLOAD",
  INVOICE_LINK_NOT_AVAILABLE: "INVOICE_LINK_NOT_AVAILABLE",
  ADDRESS: "ADDRESS",
  ENTER_ADDRESS: "ENTER_ADDRESS",
  ADDRESS_REQUIRED: "ADDRESS_REQUIRED",
  PREFERRED_ARABIC: "PREFERRED_ARABIC",
  COMPETITIONS_NAME: "COMPETITIONS_NAME",
  CANCEL_MEMBERSHIP: "CANCEL_MEMBERSHIP",
  ARE_YOU_SURE_CANCEL_MEMBERSHIP: "ARE_YOU_SURE_CANCEL_MEMBERSHIP",
  NAFES_APPROVAL_TEXT: "NAFES_APPROVAL_TEXT"
};
